import {extractTextFromQuery} from '../../../utils/query';

export default {
  param: extractTextFromQuery,
  query: function (text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        $and: words.map(function (word) {
          return {
            organizations: {$where: {name: {$ilike: `%${word}%`}}}
          };
        })
      }
    }
  }
}
